// extracted by mini-css-extract-plugin
export default {"root":"App_root__QZPIb","App":"App_App__VCsac"};